import { render, staticRenderFns } from "./transferplanung-view.vue?vue&type=template&id=10790e78"
import script from "./transferplanung-view.vue?vue&type=script&lang=js"
export * from "./transferplanung-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports